import styled, { css } from 'styled-components'

import { IconCalendar } from '@avantstay/backoffice-vectors'

import { _M_Medium, _XS_Medium, mainColors } from '../../../../styles'
import { Badge } from '../../../Badge'
import { DefaultLink as DefaultLinkComponent } from '../../../Link'

export const ReviewHeaderWrapper = styled.div<{ $gridTemplateColumns?: string }>`
  display: grid;
  grid-template-columns: ${({ $gridTemplateColumns }) => $gridTemplateColumns || `90px 36px 1fr`};
  gap: 10px;
  align-items: center;
`

export const BadgeStyled = styled(Badge)`
  max-height: 20px;
`

export const CalendarIconContainer = styled.div<{ $backgroundColor?: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  background-color: ${({ $backgroundColor }) => $backgroundColor || mainColors.neutralLight};
  border-radius: 50%;
  border: 1px solid
    ${({ $backgroundColor }) =>
      $backgroundColor === mainColors.white ? mainColors.neutralMedium : 'transparent'};

  svg {
    width: 20px;
    height: 20px;
    min-width: 20px;
    min-height: 20px;
    color: ${({ $backgroundColor }) =>
      $backgroundColor && $backgroundColor !== mainColors.white ? mainColors.white : undefined};
  }
`

export const IconCalendarStyled = styled(IconCalendar)`
  height: 20px;
  width: 20px;
  color: ${mainColors.neutralExtraDark};
`

export const BookingInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`

export const GuestName = styled.p<{ $clickable?: boolean }>`
  ${_M_Medium};

  ${({ $clickable }) =>
    $clickable &&
    css`
      color: ${mainColors.accentMedium};
      cursor: pointer;
    `}
`

export const DefaultLink = styled(DefaultLinkComponent)`
  ${_XS_Medium};
`
